import React, { type ReactNode, useState, useCallback } from 'react';
import { style } from 'typestyle';
import navigationParentStyle from './navigation-parent.styles';
import NavigationItem, { type NavigationIcon } from '../navigation-item/navigation-item.component';

interface Props {
  readonly title: string;
  readonly icon?: NavigationIcon;
  readonly isOpen?: boolean;
  readonly isActive?: boolean;
  readonly isCollapsed?: boolean;
  readonly children: ReactNode;
}

const NavigationParent = ({ title, icon, isOpen, isActive, isCollapsed, children }: Props): React.JSX.Element => {
  const [open, setOpen] = useState(isOpen ?? false);
  const toggle = useCallback(() => {
    setOpen((prevValue) => !prevValue);
  }, [setOpen]);

  return (
    <div className={style(navigationParentStyle(isActive))}>
      <NavigationItem title={title} icon={icon} isActive={isActive} isCollapsed={isCollapsed} onClick={toggle} />
      {open && children}
    </div>
  );
};

export default NavigationParent;
